import { Alert, Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default function ProtocolMigrationModal({ show, migrating, dirty, onCancel, onConfirm }) {
  return (
    <Modal show={show} onHide={onCancel} centered backdrop={migrating ? "static" : true}>
      <Modal.Header closeButton={!migrating}>
        <Modal.Title>Migracja protokołu</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Wersja tego protokołu jest <strong>przestarzała</strong>.
        </p>
        <p>
          Zalecana jest migracja do nowszej wersji szablonu. Proces pobierze
          zaktualizowaną wersję protokołu z serwera i zastąpi bieżące dane.
        </p>
        {dirty && (
          <Alert variant="info" className="mb-0">
            Formularz zawiera niezapisane zmiany. Przed wykonaniem migracji
            należy zapisać dane — migracja spowoduje utratę wszelkich
            niezapisanych zmian.
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Anuluj
        </Button>
        <Button variant="warning" onClick={onConfirm} disabled={migrating || dirty}>
          {migrating ? (
            <>
              <FontAwesomeIcon icon={faSpinner} spin /> Pobieranie...
            </>
          ) : (
            "Migruj"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
